import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  showCreateCampaignForm: false,
  showCancelCampaignForm: false,
};

const createCampaignSlice = createSlice({
  name: 'createCampaign',
  initialState,
  reducers: {
    setShowCreateCampaignForm: (state, { payload }) => {
      state.showCreateCampaignForm = payload;
    },
    setShowCancelCampaignForm: (state, { payload }) => {
      state.showCancelCampaignForm = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: createCampaignReducer } = createCampaignSlice;
export const { setShowCreateCampaignForm, setShowCancelCampaignForm } = createCampaignSlice.actions;
